// Function to get cookie by name
function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
}

// Function to set cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// Function to check if the #nopop hashtag is in the URL
function hasNoPopHash() {
    return window.location.hash === '#nopop';
}

document.addEventListener('DOMContentLoaded', function () {
    // Check if the #nopop hashtag is in the URL
    if (hasNoPopHash()) {
        if (!getCookie('noAmpedPopups')) {
            // Set the cookie to remember preference for 1 year
            setCookie('noAmpedPopups', 'true', 365);
        }
    }

    // If the cookie is set, log the message
    if (getCookie('noAmpedPopups') === 'true') {
        console.log("No Popups Here!");
    }
});